import axios from "axios";
import { toast } from "react-toastify";
export const GetAllTaxTable = (data) => {
  return {
    type: "get_alltax",
    payload: data,
    loader: false,
  };
};
export const GetTaxData = (data) => {
  return {
    type: "get_taxdata",
    payload: data,
  };
};
export function getallTaxTable() {
  return (dispatch) => {
    axios({
      url: `${
        process.env.REACT_APP_API_URL
      }Tax/Get?ProjectId=${localStorage.getItem("ProjectId")}`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllTaxTable(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
